import React from "react";
import HeaderComponent from "../Header/Header";
import styles from "../Hero/styles.module.css";
import Marquee from "../  Marquee/Marquee";
import { useSiteAssets, optimized } from "../../../siteAssets";

const NewArrival = () => {
  const cartItemCount = 0;
  const assets = useSiteAssets();
  const custom = assets["new-arrivals-banner"];
  return (
    <div
      className={styles.newArr}
      style={
        custom
          ? {
              backgroundImage: `linear-gradient(to top, rgba(15,13,11,0.66), rgba(15,13,11,0.15)), url(${optimized(custom)})`,
            }
          : undefined
      }
    >
      <Marquee />
      <HeaderComponent cartCount={cartItemCount} />

      <p className={styles.newArrPar}>
        Newest <br />
        Arrivals
      </p>
   <div className={styles.newArrParPO}>
   <p className={styles.newArrPar1}>Shop all of Lormami’s latest drops</p>
   {/* <button style={{padding:"10px", background:"white", color:"black", border:"none"}}>SORT BY</button> */}
   </div>
    </div>
  );
};

export default NewArrival;
